import React from "react";

export const CompetitionsList = ({
  disciplines,
  rows,
  disciplineInfoList,
  loading,
  onOpenCompetition,
}) => {
  if (loading) {
    return (
      <div className="text-center text-white">
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  if (disciplines.length === 0) {
    return (
      <div className="text-center text-white">Aucune compétition en cours</div>
    );
  }

  return (
    <>
      <h2 className="text-center text-white mb-4">COMPÉTITIONS EN COURS</h2>
      {rows.map((row, i) => (
        <div className="row mb-3" key={i}>
          {row.map((sport) => {
            const info = disciplineInfoList.find(
              (d) => d.name === sport.disc_code
            );
            const Icon = info?.icon;

            return (
              <div className="col-sm-6 col-lg-3 mb-3" key={sport.disc_code}>
                <div className="card text-center shadow-lg border-0 rounded-4 hover-scale">
                  <div
                    className="card-body p-4"
                    style={{
                      background: info?.color || "#444",
                      color: "white",
                    }}
                  >
                    {Icon && <Icon size={32} />}
                    <h5 className="card-title mt-2">{sport.disc_design}</h5>
                    <p className="card-text">
                      <a
                        href="#!"
                        onClick={(e) => {
                          e.preventDefault();
                          onOpenCompetition(sport.disc_code); // <-- ouvre le menu dans Dashboard
                        }}
                        style={{
                          color: "inherit",
                          textDecoration: "underline",
                        }}
                      >
                        <strong>
                          <em>Plus de détails : {sport.nb_rencontres}</em>
                        </strong>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};
